export enum OrgPermissions {
  VIEW_PROJECTS = 1,
  EDIT_PROJECTS = 2,
  BILLING = 4,
  MANAGE_USER_PERMISSIONS = 8,
  MANAGE_ORGANISATION_SETTINGS = 32768,
}
